<script>
import { required } from "vuelidate/lib/validators";
export default {
    name: "ReturnPRModal",
    data() {
        return {
            form: {
                id: null,   
                remarks: "",
            },
            submitted: false,
        };
    },
    props: {
        isReturn: {
            type: Boolean,
            default: true,
        },
    },
    validations: {
        form: { remarks: { required } },
    },
    methods: {
        updateData(data) {
            this.form = JSON.parse(JSON.stringify(data));
            this.submitted = false;
            this.$v.$reset();
        },
        onSubmit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.$emit("submit", this.form);
        },
    },
};
</script>
<template>
    <b-modal
        id="return-modal"
        :title="`${isReturn ? 'Return' : 'Cancel'} Remarks`"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form @submit.prevent="onSubmit" class="needs-validation">
            <b-row>
                <b-col>
                    <div class="mb-3">
                        <label for="description">Remarks </label>
                        <textarea
                            id="description"
                            rows="3"
                            v-model="form.remarks"
                            placeholder="Enter Remarks..."
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    submitted && $v.form.remarks.$error,
                            }"
                        ></textarea>
                        <div
                            v-if="submitted && $v.form.remarks.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.form.remarks.required"
                                >This value is required.</span
                            >
                        </div>
                    </div>
                </b-col>
            </b-row>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    {{isReturn ? 'Return' : 'Cancel'}} PR
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('return-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>